import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companySearchCarPart = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/search/car-parts',

        company: '',
        brand: '',
        model: '',
        category: '',
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        company: state => state.company,

        brand: state => state.brand,

        model: state => state.model,

        category: state => state.category,
    },
};
